import ajax from './ajax';
import { API_DOMAIN } from '../utils/constants';

const post = async (action, data) => {
  const response = await ajax(`${API_DOMAIN}/api/a/cod-risk-feedback/${action}`, data, 'POST', true);
  const status = response?.status ?? response?.code;
  if (status !== undefined && Number(status) !== 200) {
    throw new Error(response.message || response.msg || 'Request failed.');
  }
  return response.data;
};

export const exportRiskOrders = data => post('export', data);
export const previewRiskOrders = data => post('preview', data);
export const submitRiskOrders = data => post('submit', data);
export const getRiskOrderRecords = data => post('records', data);
